var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.splittedText),function(t){return _c('span',{staticClass:"title_bg"},[_c('span',{staticClass:"title_text"},[_vm._v(_vm._s(t))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }